import React from 'react';
import _ from 'lodash';

import {
  authUtil,
  routeDirectory
} from 'modules/layer00';

import { useAuthRedirectorLazyQuery } from 'generated/graphql';
import { authService } from 'iron-forge-react-modules';
import { useNavigate } from 'react-router-dom';



export interface ITuple {
  loading: boolean;
  data: IData;
}

export interface IData {
  authStatus: authService.IStatus;
  hasUser: boolean;
  isSuperAdmin: boolean;
  canView: boolean;
}



export function useQuery() {
  const navigate = useNavigate();
  const authState = authUtil.useAuthState({
    onLogOut: () => {
      if (window.location.pathname !== routeDirectory.auth.logIn.path()) {
        navigate(routeDirectory.auth.logIn.path());
      }
    }
  });
  const [fnQuery, queryTuple] = useAuthRedirectorLazyQuery();

  React.useEffect(
    () => {
      if (authState.status === 'loggedIn') {
        fnQuery({});
      }
    },
    [
      authState.status,
      fnQuery
    ]
  );



  return React.useMemo(
    () => ({
      authStatus: authState.status,
      loading: queryTuple.loading,
      didCall: queryTuple.called,
      canView: queryTuple.data?.loggedInUser?.status.name === 'approved',
      hasUser: !_.isNil(queryTuple.data?.loggedInUser),
      isSuperAdmin: queryTuple.data?.loggedInUser?.isSuperAdmin ?? false
    }),
    [
      authState,
      queryTuple
    ]
  );
}
